import Layout from "../components/Layout";
import LogInForm  from "../components/LogInForm";

import styles from "./log-in.module.scss"
import { useRouter } from 'next/router';
import { GetServerSideProps } from 'next'
import { MenuId } from "../components/Header";
import {serialize} from 'cookie'
import { getWpCookieName } from "../lib/wp-login";
import Head from 'next/head';

export default function LogIn<Props>() {


  const router = useRouter();
  
  const {action, redirect_to, email, wp_nonce} = router.query;
 
  let redirectUrl = '/my-account';

  if (typeof redirect_to === 'string')
  {
    redirectUrl = redirect_to as string;
  }

  return (
  
    <Layout menuId={MenuId.account} hidePopUp>   
      <Head>
            <link rel='canonical' href={process.env.ROOT_PATH + '/log-in'} key="canonical"/>
    </Head>  
        <div className = {styles.login}>
        <LogInForm redirect={redirectUrl} defaultEmail={email as string}/>
        </div>
     
    </Layout>
  );
}


export const getServerSideProps : GetServerSideProps = async (context)=>
{
  
  const {action, redirect_to} = context.query;

  if (action=='logout')
  {   
   
    let cookie = serialize(await getWpCookieName(), '', {path:'/',  httpOnly:true, secure:true, maxAge:0});
    context.res.setHeader("Set-Cookie", cookie);

    let url = "/";

    if (redirect_to !== undefined && typeof redirect_to ==='string')
    {
        url = redirect_to as string;
    }

    return {
      redirect: 
      {
        destination: url,
        permanent: false
      }
    }

  }

  return {
    props: {},
  }


}

/*

LogIn.getInitialProps = async (ctx : NextPageContext) =>
{
  const action = ctx.query
}
*/